import './omcDialog/index';
import './general-dialogs.service';
import './modal-dialog/modal-dialog.component';
import './modal-dialog/modal-dialog.service';
import './batch-confirm-dialog/batch-confirm-dialog.component';
import './batch-confirm-dialog/artefact-list/artefact-list.component';
import './confirm-dialog/confirm-dialog.component';
import './user-details-dialog/user-details-dialog.component';